/**
 * Local Delivery - Postal validation (SG 6-digit, sector 01-82)
 */
(function () {
  'use strict';

  var HOSPITAL_POSTAL_CODES = [
    '169608','119074','308433','529889',
    '768828','159964','228510','258500',
    '574623','188770','229899','307506',
    '329563','238859','258499','248649',
    '308443','119082','168582','168753',
    '168938','169609','169856','329562',
    '427990','529895','544835','544886',
    '569766','609606','768024',
  ];

  function isHospitalPostal(code) {
    var p = String(code || '').trim();
    return HOSPITAL_POSTAL_CODES.indexOf(p) >= 0;
  }

  function validatePostalClient(code, excludedAreas, excludedPrefixes) {
    var p = String(code || '').trim();
    if (!/^\d{6}$/.test(p)) return { valid: false, excluded: false, hospital: false };
    var sector = parseInt(p.slice(0, 2), 10);
    if (sector < 1 || sector > 82) return { valid: false, excluded: false, hospital: false };
    var hospital = isHospitalPostal(p);
    if (hospital) return { valid: true, excluded: false, hospital: true };
    if (excludedAreas && excludedAreas.length) {
      if (excludedAreas.indexOf(p) >= 0) return { valid: true, excluded: true, hospital: false };
    }
    if (excludedPrefixes && excludedPrefixes.length) {
      var match = excludedPrefixes.some(function (pre) {
        return pre && p.indexOf(pre) === 0;
      });
      if (match) return { valid: true, excluded: true, hospital: false };
    }
    return { valid: true, excluded: false, hospital: false };
  }

  window.WF_LD_POSTAL_UTILS = {
    validatePostalClient: validatePostalClient,
    isHospitalPostal: isHospitalPostal,
  };
})();
